import request from '@/utils/request'


// 查询金价列表
export function listGoldPrice(query) {
  return request({
    url: '/gold/gold/price/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询金价分页
export function pageGoldPrice(query) {
  return request({
    url: '/gold/gold/price/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询金价详细
export function getGoldPrice(data) {
  return request({
    url: '/gold/gold/price/detail',
    method: 'get',
    params: data
  })
}

// 新增金价
export function addGoldPrice(data) {
  return request({
    url: '/gold/gold/price/add',
    method: 'post',
    data: data
  })
}

// 修改金价
export function updateGoldPrice(data) {
  return request({
    url: '/gold/gold/price/edit',
    method: 'post',
    data: data
  })
}

// 删除金价
export function delGoldPrice(data) {
  return request({
    url: '/gold/gold/price/delete',
    method: 'post',
    data: data
  })
}
